import { AppraisalSeasonDto, TargetCorrectionPaymentAllowedYearsDto, TargetCorrectionPaymentDto } from '../../../../../types'

const existingWrongTCPaymentsForLowEmployee = (
  currentAppraisalSeason: AppraisalSeasonDto,
  targetCorrectionPaymentAllowedYears: TargetCorrectionPaymentAllowedYearsDto,
  activeTargetCorrectionPayment?: TargetCorrectionPaymentDto | null,
): boolean => {
  if (activeTargetCorrectionPayment) {
    const currentAppraisalSeasonYear = currentAppraisalSeason.year
    const tcpYear = activeTargetCorrectionPayment.referenceYear
    return (
      ![currentAppraisalSeasonYear, currentAppraisalSeasonYear - 1].includes(tcpYear) ||
      (tcpYear === currentAppraisalSeasonYear && !targetCorrectionPaymentAllowedYears.currentYearAllowed) ||
      (tcpYear === currentAppraisalSeasonYear - 1 && !targetCorrectionPaymentAllowedYears.previousYearAllowed)
    )
  }
  return false
}

const round2digits = (num: number): number => {
  const rounded = Number(num.toFixed(2))
  return rounded === -0 ? 0 : rounded // Explicitly handle -0 case
}

export { existingWrongTCPaymentsForLowEmployee, round2digits }
